var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}]},[_c('div',{staticClass:"page-overlay"},[_c('div',{ref:"overlay",staticClass:"overlay-lightbox",class:_vm.lightboxClasses},[_c('div',{staticClass:"overlay-content",class:_vm.overlayContentClasses},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }